export class IManufacturerInfoModel {
    name!: string;
    street1!: string;
    street2!: string;
    city!: string;
    state!: string;
    postalCode!: string;
    country!: string;
}

export class ManufacturerInfoModel {
    private _name: string;
    private _street1!: string;
    private _street2!: string;
    private _city!: string;
    private _state!: string;
    private _postalCode!: string;
    private _country!: string;

    constructor(manufacturerInfo?: IManufacturerInfoModel) {
        if(!manufacturerInfo) {
            manufacturerInfo = {
                name: "",
                street1: "",
                street2: "",
                city: "",
                state: "",
                postalCode: "",
                country: ""
            }
        }

        this._name = manufacturerInfo.name;
        this._street1 = manufacturerInfo.street1;
        this._street2 = manufacturerInfo.street2;
        this._city = manufacturerInfo.city;
        this._state = manufacturerInfo.state;
        this._postalCode = manufacturerInfo.postalCode;
        this._country = manufacturerInfo.country;
    }

    get name() {
        return this._name;
    }

    get street1() {
        return this._street1;
    }

    get street2() {
        return this._street2;
    }
    
    get city() {
        return this._city;
    }
    
    get state() {
        return this._state;
    }
    
    get postalCode() {
        return this._postalCode;
    }
    
    get country() {
        return this._country;
    }
    
    set name(name: string) {
        this._name = name;
    }

    set street1(street1: string) {
        this._street1 = street1;
    }

    set street2(street2: string) {
        this._street2 = street2;
    }
    
    set city(city: string) {
        this._city = city;
    }
    
    set state(state: string) {
        this._state = state;
    }
    
    set postalCode(postalCode: string) {
        this._postalCode = postalCode;
    }
    
    set country(country: string) {
        this._country = country;
    }
    
    public static parseValues(json: any) {
        if (!json) {
          return new ManufacturerInfoModel();
        }
    
        const manufacturerInfo = {
          name: json.name,
          street1: json.street1,
          street2: json.street2,
          city: json.city,
          state: json.state,
          postalCode: json.postalCode,
          country: json.country
        };
    
        return new ManufacturerInfoModel(manufacturerInfo);
      }
}
